import { render, staticRenderFns } from "./LmDocumentsNewOrEdit.vue?vue&type=template&id=3aea09b1&scoped=true&"
import script from "./LmDocumentsNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmDocumentsNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmDocumentsNewOrEdit.vue?vue&type=style&index=0&id=3aea09b1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aea09b1",
  null
  
)

export default component.exports